export const BUSINESS_LOGO = {
  "@type": "ImageObject",
  url: "https://1woodfloors.com/1-wood-floors-logo.png",
  contentUrl: "https://1woodfloors.com/1-wood-floors-logo.png",
  width: 227,
  height: 154,
  caption: "1 Wood Floors logo",
};

// Preserve every field except logo, including nested business records.
export function withBusinessLogos(value) {
  if (Array.isArray(value)) return value.map(withBusinessLogos);
  if (!value || typeof value !== "object") return value;
  const result = Object.fromEntries(Object.entries(value).map(([key, child]) => [key, withBusinessLogos(child)]));
  const types = Array.isArray(value["@type"]) ? value["@type"] : [value["@type"]];
  if (types.some(type => ["Organization", "LocalBusiness", "HomeAndConstructionBusiness"].includes(type))) {
    result.logo = { ...BUSINESS_LOGO };
  }
  return result;
}